import React, { useState } from "react";
import { Box, Card, CardContent, Typography, TextField, Button, Alert, CircularProgress } from "@mui/material";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

interface Props {
  onLogin: () => void;
}

export function LoginView({ onLogin }: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      // Check for admin claim
      const token = await cred.user.getIdTokenResult();
      if (!token.claims.admin) {
        await auth.signOut();
        setError("This account doesn't have admin access.");
        setLoading(false);
        return;
      }
      onLogin();
    } catch (err: any) {
      setError(err.message?.replace("Firebase: ", "") || "Login failed.");
    }
    setLoading(false);
  };

  return (
    <Box sx={{
      minHeight: "100vh",
      bgcolor: "background.default",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <Card sx={{ width: "100%", maxWidth: 400 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography variant="h5" fontWeight={800} color="primary.main">
              NeuroFlow
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              SageTech Admin Dashboard
            </Typography>
          </Box>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <form onSubmit={handleLogin}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              sx={{ mb: 3 }}
              required
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ fontWeight: 700, py: 1.5 }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Sign In"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
